import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { isCertificateTemplate } from 'shared';
import { useCurrentParticipant } from '@/hooks/useAuth';
import { useMyBadges } from '@/hooks/useParticipantBadges';
import BadgesList from '@/components/BadgesList';
import { useAuthStore } from '@/stores/auth';

export default function BadgesPage() {
  const { user } = useAuthStore();
  const participantId = typeof user?.id === 'number' ? user.id : undefined;
  const participantName = user?.name ?? '';
  const badgesQuery = useMyBadges(participantId);
  // The certificate artwork depends on the digger's centro habitual, which
  // only the full participant record carries.
  const participantQuery = useCurrentParticipant();
  const rawTemplate = participantQuery.data?.certificateTemplate;
  const certificateTemplate = isCertificateTemplate(rawTemplate) ? rawTemplate : null;
  const centerName = participantQuery.data?.digitalCenterName ?? null;

  // Go marshals empty slices as JSON null; coalesce so downstream .length/.map are safe.
  const badges = useMemo(
    () => badgesQuery.data?.badges ?? [],
    [badgesQuery.data],
  );

  return (
    <>
      <Helmet>
        <title>Badges | AICD</title>
      </Helmet>
      <div className="space-y-6">
        <header className="space-y-3">
          <Link
            to="/profile"
            aria-label="Voltar ao perfil"
            className="inline-flex items-center gap-1 text-sm font-semibold text-muted-foreground hover:text-foreground"
          >
            <BackGlyph />
            Voltar
          </Link>
          <div>
            <h1 className="text-2xl font-black text-foreground">Badges</h1>
            <p className="mt-1 subtitle text-sm text-muted-foreground">
              Os badges e certificações que recebeu.
            </p>
          </div>
        </header>

        <BadgesList
          isLoading={badgesQuery.isLoading}
          isError={badgesQuery.isError}
          badges={badges}
          participantName={participantName}
          participantReady={!participantQuery.isLoading}
          certificateTemplate={certificateTemplate}
          centerName={centerName}
        />
      </div>
    </>
  );
}

function BackGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.5}>
      <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
